import {Injectable} from "@angular/core";
import * as _ from 'lodash';
import { VEHICLE_APPLICANT, VEHICLE_FINANCINGCommercial_title, VEHICLE_FINANCINGProcessing_type, VEHICLE_FINANCINGValue_type, VEHICLE_LOAN, VEHICLE_LOANCOMMENTS, VEHICLE_LOANFUNDING, VEHICLE_LOANVEHICLES } from 'src/models/vehicle_loan.model';
import {  base_phone_country_alpha2, base_employee_of_lender_types, XPRESS_APPLICANT, XPRESS_LOAN, XPRESS_ACCOUNT_TYPESACCOUNT_TYPETerm_type, account_type, BASE_LOAN_STATUSLoan_status, BASE_FUNDING_INFOPayment_frequency } from 'src/models/xpress_loan.model';
import { BASE_APPLICANTDeclined_answer_race_gender, CREDITCARD_APPLICANT, CREDITCARD_FUNDING_INFOPayment_method, CREDITCARD_LOAN, CREDITCARD_LOAN11, CREDITCARD_LOAN_INFOCard_type, CREDITCARD_LOANCOMMENTS, CREDITCARD_LOANFUNDING, CREDITCARD_LOANFUNDINGINSURANCE_OPTIONSLoan_class } from 'src/models/creditcard_loan.model';
import { PERSONAL_APPLICANT, PERSONAL_LOAN, PERSONAL_LOANFUNDING } from 'src/models/personal_loan.model';
import { BASE_CONTACT_INFOPreferred_contact_method, BASE_MONTHLY_DEBT } from 'src/models/common.model';
import * as moment from "moment";


@Injectable(
    {
        providedIn: "root"
    }
)
export class ApplicantService {


    constructor()    {

    }

    initApplicants(){

    }

    initXpressApplicant(){
       var xpressApplicant: XPRESS_APPLICANT ={
        FINANCIAL_INFO : {}as any,
        ID_CARD : {
            card_type: "DRIVERS_LICENSE"
        } as any
       } as any;
       return xpressApplicant;
    }

    initCreditCardApplicant(){
       var creditCardApplicant :CREDITCARD_APPLICANT = {
            is_declined: "N",
            first_name:  "",
            last_name: "",
            m_initial: "",
            middle_name: "",
            ssn: "",
            dob: "",
            ages_of_dependents: "",
            mother_maiden_name: "",
            citizenship: "",
            member_number: "",
            //bankruptcy_score: "656",
            membership_months: "0",
            gender: "FEMALE",
            number_in_household: "1",
            //credit_score: "700",
            custom_score: "0",
            custom_score_2: "0",
            applicant_type: "P",
            allow_direct_mail: "Y",
            allow_email_solicit: "Y",
            allow_telemarket: "Y",
            allow_share_info: "Y",
            is_ofac_id_ver: "N",
            id_authentication_result: "INCOMPLETE", is_fraud_prescore: "N", is_fraud_fas: "N", is_fraud_credit: "N", is_ofac_credit: "N", combined_unsecured_aggregate_amount_with_lender: 0.00, borrower_id: "0",
            CONTACT_INFO: {
              preferred_contact_method: BASE_CONTACT_INFOPreferred_contact_method.CELL,
              cell_phone: "",
              cell_phone_country: base_phone_country_alpha2.US,
              fax_number: "",
              fax_number_country: base_phone_country_alpha2.US,
              home_phone: "",
              home_phone_country: base_phone_country_alpha2.US,
              work_phone: "", work_phone_extension: "",
              work_phone_country: base_phone_country_alpha2.US, email: ""
            } as any,
            CURRENT_ADDRESS: {
  
            },
            MAILING_ADDRESS:{
             
            },
            FINANCIAL_INFO: {
              CURRENT_EMPLOYMENT: [{
                employment_start_date: new Date(),
                employed_months: "0",
                employment_address: "",
                employment_city: "",
                employment_state: "",
                employment_zip: "",
                occupation: "",
                // employer: "APPLE",
                employment_phone: "",
                //employment_status: BASE_EMPLOYMENTEmployment_status.GOV,
                employment_weekly_hours: 0,
                is_employee_of_lender: BASE_APPLICANTDeclined_answer_race_gender.N,
                employee_of_lender_type: base_employee_of_lender_types.NONE,
                profession_months: "0"
              } as any],
              PREVIOUS_EMPLOYMENT: [{
                monthly_income: 0, employed_months: "0", employment_address: "", employment_city: "", employment_state: "", occupation: "", employer: "", employment_phone: "", employment_weekly_hours: 0
              } as any],
              MONTHLY_DEBT: new BASE_MONTHLY_DEBT(),
              MONTHLY_INCOME: {
                is_monthly_income_base_salary_manual: BASE_APPLICANTDeclined_answer_race_gender.Y,
                // monthly_income_base_salary: 0,
                is_tax_exempt_monthly_income_base_salary: BASE_APPLICANTDeclined_answer_race_gender.N,
                monthly_income_over_time: 0,
                monthly_income_bonus: 0,
                income_verify_method: ""
              } as any
            }
          } as any;

        return creditCardApplicant;
    }

    initVehicleApplicant(){
        var vehicleApplicant : VEHICLE_APPLICANT = {
          CONTACT_INFO: {
            preferred_contact_method: BASE_CONTACT_INFOPreferred_contact_method.CELL,
            cell_phone: "",
            cell_phone_country: base_phone_country_alpha2.US,
            fax_number: "",
            fax_number_country: base_phone_country_alpha2.US,
            home_phone: "",
            home_phone_country: base_phone_country_alpha2.US,
            work_phone: "", work_phone_extension: "",
            work_phone_country: base_phone_country_alpha2.US, email: ""
          } as any,
          CURRENT_ADDRESS: {

          },
          // MAILING_ADDRESS:{
           
          // },
          FINANCIAL_INFO: {
            CURRENT_EMPLOYMENT: [{
              employment_start_date: new Date(),
              employed_months: "0",
              employment_address: "",
              employment_city: "",
              employment_state: "",
              employment_zip: "",
              occupation: "",
              employment_phone: "",
              employment_status:0,
              employment_weekly_hours: 0,
              is_employee_of_lender: BASE_APPLICANTDeclined_answer_race_gender.N,
              employee_of_lender_type: base_employee_of_lender_types.NONE,
              profession_months: "0"
            } as any],
            PREVIOUS_EMPLOYMENT: [{
              monthly_income: 0, employed_months: "0", employment_address: "", employment_city: "", employment_state: "", occupation: "", employer: "", employment_phone: "", employment_weekly_hours: 0
            } as any],
            MONTHLY_DEBT: new BASE_MONTHLY_DEBT(),
            MONTHLY_INCOME: {
              is_monthly_income_base_salary_manual: BASE_APPLICANTDeclined_answer_race_gender.Y,
              // monthly_income_base_salary: 0,
              is_tax_exempt_monthly_income_base_salary: BASE_APPLICANTDeclined_answer_race_gender.N,
              monthly_income_over_time: 0,
              monthly_income_bonus: 0,
              income_verify_method: ""
            } as any
          }
        } as any;
        return vehicleApplicant;
    }
    
    initPersonalApplicant(){
        var personalApplicant : PERSONAL_APPLICANT = {
          CONTACT_INFO: {
            preferred_contact_method: BASE_CONTACT_INFOPreferred_contact_method.CELL,
            cell_phone: "",
            cell_phone_country: base_phone_country_alpha2.US,
            fax_number: "",
            fax_number_country: base_phone_country_alpha2.US,
            home_phone: "",
            home_phone_country: base_phone_country_alpha2.US,
            work_phone: "", work_phone_extension: "",
            work_phone_country: base_phone_country_alpha2.US, email: ""
          } as any,
          CURRENT_ADDRESS: {

          },
  
          FINANCIAL_INFO: {
            CURRENT_EMPLOYMENT: [{
              employment_start_date: new Date(),
              employed_months: "0",
              employment_address: "",
              employment_city: "",
              employment_state: "",
              employment_zip: "",
              occupation: "",
              employment_phone: "",
              employment_status:0,
              employment_weekly_hours: 0,
              is_employee_of_lender: BASE_APPLICANTDeclined_answer_race_gender.N,
              employee_of_lender_type: base_employee_of_lender_types.NONE,
              profession_months: "0"
            } as any],
            PREVIOUS_EMPLOYMENT: [{
              monthly_income: 0, employed_months: "0", employment_address: "", employment_city: "", employment_state: "", occupation: "", employer: "", employment_phone: "", employment_weekly_hours: 0
            } as any],
            MONTHLY_DEBT: new BASE_MONTHLY_DEBT(),
            MONTHLY_INCOME: {
              is_monthly_income_base_salary_manual: BASE_APPLICANTDeclined_answer_race_gender.Y,
              // monthly_income_base_salary: 0,
              is_tax_exempt_monthly_income_base_salary: BASE_APPLICANTDeclined_answer_race_gender.N,
              monthly_income_over_time: 0,
              monthly_income_bonus: 0,
              income_verify_method: ""
            } as any
          }
        } as any;

        return personalApplicant;
    }

    fillOtherApplicants(xpressApplicant, vehicleApplicant, personalApplicant, creditCardApplicant) {
      const commonFields = ['first_name', 'last_name', 'dob', 'CURRENT_ADDRESS', 'PREVIOUS_ADDRESS', 'MAILING_ADDRESS', 'mother_maiden_name', 'FOM_ANSWERED_QUESTIONS'];
      _.each(commonFields, f => {
        try {
          xpressApplicant[f] = creditCardApplicant[f];
          if (vehicleApplicant) vehicleApplicant[f] = creditCardApplicant[f];
          if (personalApplicant) personalApplicant[f] = creditCardApplicant[f];
        } catch {}
      });
    
      // CONTACT INFO
      const contactProps = ['preferred_contact_method', 'email', 'cell_phone', 'home_phone', 'work_phone'];
      contactProps.forEach(prop => {
        const val = creditCardApplicant.CONTACT_INFO[prop];
        xpressApplicant[prop] = val;
        if (vehicleApplicant) vehicleApplicant.CONTACT_INFO[prop] = val;
        if (personalApplicant) personalApplicant.CONTACT_INFO[prop] = val;
      });
    
      xpressApplicant.preferred_contact_methodSpecified = true;
    
      // MONTHLY INCOME
      const income = creditCardApplicant.FINANCIAL_INFO.MONTHLY_INCOME.monthly_income_base_salary;
      xpressApplicant.FINANCIAL_INFO.monthly_income_base_salary = income;
      if (vehicleApplicant) vehicleApplicant.FINANCIAL_INFO.MONTHLY_INCOME.monthly_income_base_salary = income;
      if (personalApplicant) personalApplicant.FINANCIAL_INFO.MONTHLY_INCOME.monthly_income_base_salary = income;
    
      // EMPLOYMENT
      const employmentFields = ['employment_status', 'employer', 'occupation', 'pay_grade', 'employed_months', 'employment_start_date', 'employment_business_type', 'employee_of_lender_type', 'employee_of_lender_typeSpecified'];
      _.each(employmentFields, f => {
        try {
          const val = creditCardApplicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0][f];
          xpressApplicant.FINANCIAL_INFO[f] = val;
          if (vehicleApplicant) vehicleApplicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0][f] = val;
          if (personalApplicant) personalApplicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0][f] = val;
        } catch {}
      });
    
      // PREVIOUS EMPLOYMENT
      const preEmploymentFields = ['employment_status', 'employer', 'occupation', 'employed_months', 'employment_start_date'];
      _.each(preEmploymentFields, f => {
        try {
          const val = creditCardApplicant.FINANCIAL_INFO.PREVIOUS_EMPLOYMENT[0][f];
          if (vehicleApplicant) vehicleApplicant.FINANCIAL_INFO.PREVIOUS_EMPLOYMENT[0][f] = val;
          if (personalApplicant) personalApplicant.FINANCIAL_INFO.PREVIOUS_EMPLOYMENT[0][f] = val;
        } catch {}
      });
    
       // MONTHLY_DEBT
       if(creditCardApplicant.FINANCIAL_INFO.MONTHLY_DEBT && creditCardApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_liability"]){
        const liability = creditCardApplicant.FINANCIAL_INFO.MONTHLY_DEBT.monthly_liability;
        xpressApplicant.FINANCIAL_INFO["monthly_liability"] = liability;
        if (vehicleApplicant) vehicleApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_liability"] = liability;
        if (personalApplicant) personalApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_liability"] = liability;
      
        // MONTHLY RENT + HOUSING
        creditCardApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_housing_cost"] = liability;
        creditCardApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_rent"] = liability;
      
        xpressApplicant.FINANCIAL_INFO["monthly_rent"] = liability;
        if (vehicleApplicant) {
          vehicleApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_rent"] = liability;
          vehicleApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_housing_cost"] = liability;
        }
        if (personalApplicant) {
          personalApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_rent"] = liability;
          personalApplicant.FINANCIAL_INFO.MONTHLY_DEBT["monthly_housing_cost"] = liability;
        }
      }else{
        delete  xpressApplicant.FINANCIAL_INFO["monthly_liability"];
      }
    }
    
    
    

    fillContact_CreditCardApplicants(creditCardApplicant){
      if(!creditCardApplicant.CONTACT_INFO.home_phone){
        creditCardApplicant.CONTACT_INFO.home_phone = creditCardApplicant.CONTACT_INFO.cell_phone;
       }   
    }


      initInterestedAccounts(selectedProducts){
        selectedProducts = _.filter(selectedProducts,p=>{
          return  p.applicationType ==1;
        })
        var interestedAccounts = _.map(selectedProducts, p=>{
          
          var acc =
          {
            "min_deposit": p.minDeposit,
            "account_name":  p.name,
            "account_type":  p.accountType,
            "account_number": "",
            "rate": p.rate || 0,
            "apy": p.apy || 0,
            "suffix":"",
            "is_rate_override": "N",
            //"clf_approved_account_type_id": "3",
            "interest_rate_type": "FIXED",
            "cd_additions_permitted": "N",
            "cd_renewability": "",
            "term_type": "M",
            "term": p.maxTerm || 0,
            "termSpecified" : !!p.maxTerm,
            "product_code": p.productCode
          } as any;
          if(p.maxTerm && p.productGroupId == 3){
            acc.maturity_date= moment().add(p.maxTerm,'month').toDate();
            acc.maturity_dateSpecified = true;
          }else{
            acc.maturity_date= new Date();
            acc.maturity_dateSpecified = false;
          }

          return acc;

        })

        return interestedAccounts;
      }



      initDataVehicle() {
        var vehicleLoan = new VEHICLE_LOAN();
        vehicleLoan.version = 5.248; 
        vehicleLoan.SYSTEM =[
          {
            BRANCH: {
              name: "test"
            } as any
          } as any
        ]
        var vehicleApplicant = this.initVehicleApplicant();
        vehicleLoan.APPLICANTS = {
          APPLICANT: [vehicleApplicant],
          selected_product_borrower_id: ""
        };
    
        vehicleLoan.VEHICLES = new VEHICLE_LOANVEHICLES();
        vehicleLoan.LOAN_INFO = {
          //amount_requested:3.14,
          //loan_term:"3",
          rate_code: "",
          max_underwrite_amount: "0",
          epl_fees_total: 0,
          is_claimed: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_complete_consumer: BASE_APPLICANTDeclined_answer_race_gender.N,
          require_product_refresh: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_addon: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_amendment: BASE_APPLICANTDeclined_answer_race_gender.N,
          solve_for: "TERM",
          is_possible_dupe: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_workout_loan: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_solvefor_manual: BASE_APPLICANTDeclined_answer_race_gender.N,
          tier: "0",
          tier_previous: "0",
          is_prequalification_applied: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_ofac: BASE_APPLICANTDeclined_answer_race_gender.N,
          has_balance_transfer: BASE_APPLICANTDeclined_answer_race_gender.N,
          card_type: CREDITCARD_LOAN_INFOCard_type.CREDIT,
          card_number: "",
          expire_date: "",
          card_name: "",
          apr: 0,
          intro_apr: 0,
          apr_balance_transfer: 0,
          intro_apr_balance_transfer: 0.000, apr_cash_advances: 0.000,
          intro_apr_cash_advances:
            0.000, apr_other: 0.000, intro_apr_other: 0.000,
          monthly_payment: 0.00, credit_limit: 0.00,
          current_credit_limit: 0.00,
          requested_credit_limit: 0.00,
          requested_card_name: "",
    
          CARD_HOLDERS: [{
            order_card: BASE_APPLICANTDeclined_answer_race_gender.N,
            first_name: "",
            last_name: "",
            m_initial: "",
    
          }],
          amount_approved_variance: 0.00,
          is_advance_request: BASE_APPLICANTDeclined_answer_race_gender.N,
          purpose_type: "",
          current_card_rate: 0.000,
          current_card_margin: 0.000
        } as any;
    
        vehicleLoan.PRICE_ADJUSTMENTS = [];
    
        vehicleLoan.LOAN_STATUS =
          {
            loan_status: BASE_LOAN_STATUSLoan_status.PEN,
            initial_entry_timestamp: "2015-05-19T16:51:11-07:00",
            last_modified: "2015-05-19T16:53:30-07:00",
            is_locked: BASE_APPLICANTDeclined_answer_race_gender.N,
            existing_balance: 0.00,
            delinquency_period: "0",
            delinquency_amount: 0.00,
            //app_receive_date: "2015-05-19"
          } as any;
    
        vehicleLoan.FUNDING = {
          daily_periodic_rate: 0,
          payment_frequency: BASE_FUNDING_INFOPayment_frequency.MONTHLY,
          payment_method: CREDITCARD_FUNDING_INFOPayment_method.MINPAYMENT,
          misc_implant: "",
          index: 0,
          margin: 0,
          floor: 0,
          ceiling: 0,
          payment_method_set_payment: 0,
          INSURANCE_OPTIONS: { loan_class: CREDITCARD_LOANFUNDINGINSURANCE_OPTIONSLoan_class.O, description: "" } as any
        } as any as VEHICLE_LOANFUNDING;
        vehicleLoan.DISBURSEMENTS = [];
        vehicleLoan.TASK_LIST = [];
        vehicleLoan.COMMENTS = new VEHICLE_LOANCOMMENTS();
    
        vehicleLoan.VEHICLES.VEHICLE= [{
                  mileage:"0" ,
                  vehicle_sales_price:0 ,
                  vehicle_value:0 ,
                  vehicle_value_type:"RETAIL" ,
                  is_rebuilt_restored:BASE_APPLICANTDeclined_answer_race_gender.Y ,
                  processing_type:VEHICLE_FINANCINGProcessing_type.MPLM ,
                  vehicle_options:"" ,
                  value_type:VEHICLE_FINANCINGValue_type.NONE,
                  vin:"N/A",
                    year:"0" ,
                    make:"",
                      nada_info:"", 
                      commercial_title: VEHICLE_FINANCINGCommercial_title.NONE
                } as any];

        return vehicleLoan;        
      }
    
      initDataPersonal() {
        var personalLoan = new PERSONAL_LOAN();
        personalLoan.version = 5.248; 
        personalLoan.SYSTEM =[
          {
            BRANCH: {
              name: "test"
            } as any
          } as any
        ]
        var personalApplicant = this.initPersonalApplicant();
        personalLoan.APPLICANTS = {
          APPLICANT: [personalApplicant],
          selected_product_borrower_id: ""
        };  
        personalLoan.LOAN_INFO = {
          //amount_requested:3.14,
          //loan_term: "3",
          rate_code: "",
          max_underwrite_amount: "0",
          epl_fees_total: 0,
          is_claimed: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_complete_consumer: BASE_APPLICANTDeclined_answer_race_gender.N,
          require_product_refresh: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_addon: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_amendment: BASE_APPLICANTDeclined_answer_race_gender.N,
          solve_for: "TERM",
          is_possible_dupe: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_workout_loan: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_solvefor_manual: BASE_APPLICANTDeclined_answer_race_gender.N,
          tier: "0",
          tier_previous: "0",
          is_prequalification_applied: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_ofac: BASE_APPLICANTDeclined_answer_race_gender.N,
          has_balance_transfer: BASE_APPLICANTDeclined_answer_race_gender.N,
          card_type: CREDITCARD_LOAN_INFOCard_type.CREDIT,
          card_number: "",
          expire_date: "",
          card_name: "",
          apr: 0,
          intro_apr: 0,
          apr_balance_transfer: 0,
          intro_apr_balance_transfer: 0.000, apr_cash_advances: 0.000,
          intro_apr_cash_advances:
            0.000, apr_other: 0.000, intro_apr_other: 0.000,
          monthly_payment: 0.00, credit_limit: 0.00,
          current_credit_limit: 0.00,
          requested_credit_limit: 0.00,
          requested_card_name: "",
    
          CARD_HOLDERS: [{
            order_card: BASE_APPLICANTDeclined_answer_race_gender.N,
            first_name: "",
            last_name: "",
            m_initial: "",
    
          }],
          amount_approved_variance: 0.00,
          is_advance_request: BASE_APPLICANTDeclined_answer_race_gender.N,
          purpose_type: "",
          current_card_rate: 0.000,
          current_card_margin: 0.000
        } as any;
    
        personalLoan.PRICE_ADJUSTMENTS = [];
    
        personalLoan.LOAN_STATUS =
          {
            loan_status: BASE_LOAN_STATUSLoan_status.PEN,
            initial_entry_timestamp: "2015-05-19T16:51:11-07:00",
            last_modified: "2015-05-19T16:53:30-07:00",
            is_locked: BASE_APPLICANTDeclined_answer_race_gender.N,
            existing_balance: 0.00,
            delinquency_period: "0",
            delinquency_amount: 0.00,
          } as any;
    
        personalLoan.FUNDING = {
          daily_periodic_rate: 0,
          payment_frequency: BASE_FUNDING_INFOPayment_frequency.MONTHLY,
          payment_method: CREDITCARD_FUNDING_INFOPayment_method.MINPAYMENT,
          misc_implant: "",
          index: 0,
          margin: 0,
          floor: 0,
          ceiling: 0,
          payment_method_set_payment: 0,
          INSURANCE_OPTIONS: { loan_class: CREDITCARD_LOANFUNDINGINSURANCE_OPTIONSLoan_class.O, description: "" } as any
        } as any as PERSONAL_LOANFUNDING;
        personalLoan.DISBURSEMENTS = [];
        personalLoan.TASK_LIST = [];
        personalLoan.COMMENTS = new VEHICLE_LOANCOMMENTS();

        return personalLoan;
      }

      initDataCreditCard(){
        var creditCardLoan = new CREDITCARD_LOAN11();
        creditCardLoan.version = 5.248;   
        creditCardLoan.SYSTEM =[
          {
            BRANCH: {
              name: "test"
            } as any
          } as any
        ]
       creditCardLoan.APPLICANTS = {
          APPLICANT: [this.initCreditCardApplicant()],
          selected_product_borrower_id: ""
        };
       creditCardLoan.LOAN_INFO = {
          rate_code: "",
          max_underwrite_amount: "0",
          epl_fees_total: 0,
          is_claimed: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_complete_consumer: BASE_APPLICANTDeclined_answer_race_gender.N,
          require_product_refresh: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_addon: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_amendment: BASE_APPLICANTDeclined_answer_race_gender.N,
          solve_for: "TERM",
          is_possible_dupe: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_workout_loan: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_solvefor_manual: BASE_APPLICANTDeclined_answer_race_gender.N,
          tier: "0",
          tier_previous: "0",
          is_prequalification_applied: BASE_APPLICANTDeclined_answer_race_gender.N,
          is_ofac: BASE_APPLICANTDeclined_answer_race_gender.N,
          has_balance_transfer: BASE_APPLICANTDeclined_answer_race_gender.N,
          card_type: CREDITCARD_LOAN_INFOCard_type.CREDIT,
          purpose_type: "New Card",
          card_number: "",
          expire_date: "",
          card_name: "",
          apr: 0,
          intro_apr: 0,
          apr_balance_transfer: 0,
          intro_apr_balance_transfer: 0.000, apr_cash_advances: 0.000,
          intro_apr_cash_advances:
            0.000, apr_other: 0.000, intro_apr_other: 0.000,
          monthly_payment: 0.00, credit_limit: 0.00,
          current_credit_limit: 0.00,
          requested_credit_limit: 0.00,
          requested_card_name: "",
    
          CARD_HOLDERS: [{
            order_card: BASE_APPLICANTDeclined_answer_race_gender.N,
            first_name: "",
            last_name: "",
            m_initial: "",
    
          }],
          amount_approved_variance: 0.00,
          is_advance_request: BASE_APPLICANTDeclined_answer_race_gender.N,
    
          current_card_rate: 0.000,
          current_card_margin: 0.000
        } as any;
       creditCardLoan.PRICE_ADJUSTMENTS = [];
    
       creditCardLoan.LOAN_STATUS =
          {
            loan_status: BASE_LOAN_STATUSLoan_status.PEN,
            initial_entry_timestamp: "2015-05-19T16:51:11-07:00",
            last_modified: "2015-05-19T16:53:30-07:00",
            is_locked: BASE_APPLICANTDeclined_answer_race_gender.N,
            existing_balance: 0.00,
            delinquency_period: "0",
            delinquency_amount: 0.00,
            //app_receive_date: "2015-05-19"
          } as any;
    
       creditCardLoan.FUNDING = {
          daily_periodic_rate: 0,
          payment_frequency: BASE_FUNDING_INFOPayment_frequency.MONTHLY,
          payment_method: CREDITCARD_FUNDING_INFOPayment_method.MINPAYMENT,
          misc_implant: "",
          index: 0,
          margin: 0,
          floor: 0,
          ceiling: 0,
          payment_method_set_payment: 0,
          INSURANCE_OPTIONS: { loan_class: CREDITCARD_LOANFUNDINGINSURANCE_OPTIONSLoan_class.O, description: "" } as any
        } as any as CREDITCARD_LOANFUNDING;
       creditCardLoan.COMMENTS = new CREDITCARD_LOANCOMMENTS();

       return creditCardLoan;
      }

}